import { render, staticRenderFns } from "./mycurriculumsixth.vue?vue&type=template&id=4408ec8c&scoped=true"
import script from "./mycurriculumsixth.vue?vue&type=script&lang=js"
export * from "./mycurriculumsixth.vue?vue&type=script&lang=js"
import style0 from "./mycurriculumsixth.vue?vue&type=style&index=0&id=4408ec8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408ec8c",
  null
  
)

export default component.exports